/**
 * Renouvellements d'année 2, par mois d'échéance — de la première jusqu'à
 * trois mois devant. Le passé avec son issue ; l'avenir avec les résiliations
 * déjà demandées (ces abonnés ne renouvelleront pas).
 *
 * Indépendant de la période choisie : c'est le calendrier des échéances.
 */

import type { RenewalMonth } from '@shared/types/sales';

import { formatInteger, formatMoney, formatMonthShort, formatPercent } from '../lib/format';
import { Card } from './Card';

interface RenewalMonthsTableProps {
  months: readonly RenewalMonth[];
  currency: string;
}

export function RenewalMonthsTable({ months, currency }: RenewalMonthsTableProps) {
  const count = (value: number) => (value > 0 ? formatInteger(value) : '—');
  return (
    <Card
      title="Renouvellements par mois d'échéance"
      subtitle="Annuels arrivant au bout de leur première année payante, issue au dernier sync — trois mois devant compris. Taux : renouvelés ÷ échéances"
      className="chart-grid__wide"
    >
      {months.length === 0 ? (
        <p className="empty">Aucun abonnement annuel n'est encore arrivé à sa première échéance.</p>
      ) : (
        <div className="table-wrap">
          <table className="data">
            <thead>
              <tr>
                <th>Échéance</th>
                <th className="num">Échéances</th>
                <th className="num">Renouvelés</th>
                <th className="num">Résiliés avant</th>
                <th className="num">Échecs de paiement</th>
                <th className="num">En relance</th>
                <th className="num">À venir</th>
                <th className="num">Taux</th>
                <th className="num">CA TTC</th>
              </tr>
            </thead>
            <tbody>
              {months.map((month) => (
                <tr key={month.month}>
                  <td>{formatMonthShort(`${month.month}-01`)}</td>
                  <td className="num">{formatInteger(month.due)}</td>
                  <td className="num">{count(month.renewed)}</td>
                  <td className="num">{count(month.canceled)}</td>
                  <td className="num">{count(month.failed)}</td>
                  <td className="num">{count(month.pending)}</td>
                  <td className="num">{count(month.upcoming)}</td>
                  <td className="num">{month.renewalRatePercent !== null ? formatPercent(month.renewalRatePercent) : '—'}</td>
                  <td className="num">{month.revenue > 0 ? formatMoney(month.revenue, currency) : '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Card>
  );
}
